module.exports = __webpack_public_path__ + "img/gift-logo.e965f3ac.svg";